<template>
  <div style="margin-bottom: 2px;" :class="[gridColumnsClass, {'has-background-white-bis' : creatingAssetType}]" class="grid gap-1 pt-075 pb-075 rounded-sml is-uppercase tracking-wide has-background-white">
    <div class="is-2-columns is-flex justify-start align-items-center pl-1 "><tag-icon style="margin-right: 0.5rem; margin-left: 0.5rem" :color="'has-text-primary'"/>Label</div>
    <div class="is-2-columns is-flex justify-start align-items-center"><maximize-icon style="margin-right: 0.5rem" :color="'has-text-primary'"/>Placeholder</div>
    <div class="is-2-columns is-flex justify-start align-items-center"><default-grid-icon style="margin-right: 0.5rem" :color="'has-text-primary'" :size="18"/>Default</div>
    <div class="is-2-columns is-flex justify-start align-items-center"><icon style="margin-right: 0.5rem" icon="list" class="has-text-primary" /> Predefined Values</div>
    <div class="is-2-columns is-flex justify-start align-items-center"><intersect-icon style="margin-right: 0.25rem" class="" :color="'has-text-primary'"/>Linked Field <icon icon="info-circle" class="has-text-primary has-tooltip is-size-7" style="margin-left: 0.5rem" data-tooltip="Filters the available predefined values based on the value chosen for the linked custom field"/></div>
    <div class="is-2-columns is-flex justify-start align-items-center pl-1"><icon icon="asterisk" class="has-text-primary is-size-7" />Required</div>
    <div class="is-2-columns is-flex justify-start align-items-center pl-1" v-if="canManageReportFields"><icon icon="file-alt" class="has-text-primary is-size-7" style="margin-right: 0.5rem"/>Add To Reports <icon icon="info-circle" class="has-text-primary has-tooltip has-tooltip-multiline is-size-7" style="margin-left: 0.5rem" :data-tooltip="`Adds the ${Naming.CustomField.toLowerCase()} to reports that do not already show it. ${Naming.CustomFields} already shown on the ${Naming.Inspection.toLowerCase()} and ${Naming.Job.toLowerCase()} reports are not affected.`"/></div>
  </div>
</template>
<script>
  import DefaultGridIcon from "@/components/ui/icons/DefaultGridIcon.vue";
  import MaximizeIcon from "@/components/ui/icons/MaximizeIcon.vue";
  import TagIcon from "@/components/ui/icons/TagIcon.vue";

  export default {
    components: {TagIcon, MaximizeIcon, DefaultGridIcon},
    props: {
      creatingAssetType: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      gridColumnsClass() {
        return this.canManageReportFields ? 'has-14-columns' : 'has-12-columns'
      },
    },
  }
</script>